import { render, staticRenderFns } from "./update-app.vue?vue&type=template&id=146d6f46&scoped=true&"
import script from "./update-app.vue?vue&type=script&lang=js&"
export * from "./update-app.vue?vue&type=script&lang=js&"
import style0 from "./update-app.vue?vue&type=style&index=0&id=146d6f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146d6f46",
  null
  
)

export default component.exports